import React, { useRef, useState, useEffect } from 'react';
// Import Swiper React components
import { Swiper, SwiperSlide } from 'swiper/react';

// Import Swiper styles
import 'swiper/css';


// import required modules
import { Autoplay } from 'swiper/modules';

import swiper1 from '../assest/partner1.png'
import swiper3 from '../assest/partner2.png'
import swiper4 from '../assest/partner3.png'
import swiper5 from '../assest/partner4.png'
import swiper6 from '../assest/partner5.png'
import { useDispatch, useSelector } from 'react-redux';
import { fetchAbout } from '../rtk/slices/about-slice';

function About () {
    const dispatch = useDispatch();
    const about = useSelector((state) => state.about.about);

    useEffect(() => {
        // fetch about
        dispatch(fetchAbout());
    }, [])
    return (
        <section className='about' id='about'>
            <div className="container">
                <h2 data-aos="fade-left" className="title">
                    <span>About</span>
                    <p>About</p>
                </h2>

                <div className="about-content">
                    {about.map((content) => {
                        return (
                            <div key={content.id} className="box">
                                <img data-aos="fade-up"
                                    data-aos-anchor-placement="top-bottom" className='image' src={`${process.env.REACT_APP_PROJECTS_API}assest/imgs/${content.img}`} alt="" />

                                <div data-aos="zoom-in" data-aos-duration="1500" className="text">
                                    {content.text}
                                </div>
                            </div>
                        )
                    })}
                </div>
                <div className="swiper_container">
                    <div className="card">
                        <i class="fa fa-map-marker"></i>
                        <h4>AGRICULTURAL LAND / PACKING STATION</h4>
                        <p>Area of 29 hectares of different production, agreement with several producers the total area exceeds 60 hectares and a packing station with an area of 7000 meters
                        </p>
                    </div>
                    <div className="card">
                        <i class="fa fa-globe"></i>
                        <h4>OUR CLIENTS</h4>
                        <p>we deliver for our customers in Spain Portugal France Germany and England</p>
                    </div>
                    <div className="card">
                        <i class="fa fa-id-card"></i>
                        <h4>OUR CERTIFICATES</h4>
                        <p>the certifications that Zamos has is GLOBAL GAP And GRASP
                        </p>
                    </div>
                </div>
            </div>
        </section>
    )
}

export default About
